import * as React from 'react';
import styled from 'styled-components';
import { themeGet, Text, FixedRatio } from '@packages/ui';
import { ImageCDNProvider, ModuleTeaserItem, publicAssetsImageSrcToCdnImageSrc } from '@packages/common';

import { CallToAction } from '../CallToAction/CallToAction';
import { MultilineText } from '../../MultilineText/MultilineText';

export type TeaserItemProps = ModuleTeaserItem & {
  onClick?: (item: TeaserItemProps) => void;
  cdnProvider?: ImageCDNProvider;
};

export const Container = styled.div`
  text-align: center;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  user-select: none;
  object-fit: cover;
  transition: transform 0.2s ease-out;
  border-radius: 6px;
`;

export const StyledCallToAction = styled(CallToAction)`
  position: relative;
  color: ${themeGet.colors('judgeGray')};
  display: block;
  user-select: none;
  &:hover,
  &:active {
    color: ${themeGet.colors('judgeGray')};
  }
`;

export const Label: any = styled(Text)`
  position: relative;
  margin-top: -28px;
  background: ${themeGet.colors('white')};
  height: 56px;
  box-shadow: 0px 9px 20px 0px rgba(43, 18, 2, 0.05);
  border-radius: 6px;
  overflow: hidden;
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;

  > span {
    max-height: 38px;
    overflow: hidden;
  }
`;

const ratio = [1, 1, 1, 1, 175 / 224, 186 / 240];

export class TeaserItem extends React.PureComponent<TeaserItemProps> {
  handleClick = () => {
    const { onClick } = this.props;
    if (onClick) {
      onClick(this.props);
    }
  };

  render() {
    const { title, image, cta, onClick, cdnProvider } = this.props;
    const src = publicAssetsImageSrcToCdnImageSrc(image, cdnProvider);

    return (
      <StyledCallToAction {...cta} onClick={onClick && this.handleClick}>
        <Container data-testid="cms-teaser-item">
          <FixedRatio ratio={ratio}>
            <Image loading="lazy" src={src} alt={title} />
          </FixedRatio>
          <Label pt={0} ml={2} pl={0} pr={0} mr={2} fontWeight={400} fontSize={4} color="">
            <span>
              <MultilineText>{title}</MultilineText>
            </span>
          </Label>
        </Container>
      </StyledCallToAction>
    );
  }
}
